  window.onload = function () {
    const stickyAddToCart = document.querySelector('sticky-add-to-cart');
    if (stickyAddToCart) {
      stickyAddToCart.style.display = 'block';
    }
  };

  if (window.location.href.includes("shipping-insurance-skip-the-line")) {
    window.location.href = "/collections/ALL";  
  }

  const updateMainCart = async (cart) => {
    try {
      const sectionId = document.querySelector('#main-cart-items').getAttribute('data-id');

      const cartElement = document.querySelector('[data-cart]');
      const cartContent = cartElement.querySelector('[data-cart-content]');
      const cartTotals = cartElement.querySelector('[data-cart-total]');

      const cartLoading = `
      <div class="loading-overlay loading-overlay--custom">
        <div class="loading-overlay__spinner">
          <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
            <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
          </svg>
        </div>
      </div>`;

      const loadingClass = 'is-loading';

      cartElement.classList.add(loadingClass);
      cartElement.insertAdjacentHTML('afterbegin', cartLoading);

      const response = await fetch(`/cart?section_id=${sectionId}`);
      const data = await response.text();

      const jsPreventedData = data.replaceAll('cart-coupon-discount', 'div');
      const parsedResponse = new DOMParser().parseFromString(jsPreventedData, 'text/html');

      cartElement.classList.remove(loadingClass);
      cartElement.querySelector('.loading-overlay').remove();

      if (cart.item_count > 0) {
        const contentCart = parsedResponse.querySelector('[data-cart-content] .cart').innerHTML;
        const subTotal = parsedResponse.querySelector('[data-cart-total] .cart-total-subtotal').innerHTML;
        const grandTotal = parsedResponse.querySelector('[data-cart-total] .cart-total-grandtotal').innerHTML;
        const savings = parsedResponse.querySelector('[data-cart-total] .cart-total-savings').innerHTML;

        cartContent.querySelector('.cart').innerHTML = contentCart;
        cartTotals.querySelector('.cart-total-subtotal').innerHTML = subTotal;
        cartTotals.querySelector('.cart-total-grandtotal').innerHTML = grandTotal;
        cartTotals.querySelector('.cart-total-savings').innerHTML = savings;

        const calculatorShipping = parsedResponse.querySelector('.haloCalculatorShipping');
        if (calculatorShipping) {
          const existingCalculator = cartElement.querySelector('.haloCalculatorShipping');
          if (existingCalculator) {
            existingCalculator.replaceWith(calculatorShipping);
          }
        }

        document.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));

        document.querySelectorAll('[data-free-shipping-wrapper]').forEach(freeShippingWrapper => {
          const changeEvent = new Event('change', { bubbles: true })
          freeShippingWrapper.dispatchEvent(changeEvent);
        })
      } else {
        const contentCart = parsedResponse.querySelector('#main-cart-items').innerHTML;
        const headerCart = parsedResponse.querySelector('.page-header').innerHTML;

        document.querySelector('#main-cart-items').innerHTML = contentCart;
        document.querySelector('.page-header').innerHTML = headerCart;

        document.querySelectorAll('[data-free-shipping-wrapper]').forEach(freeShippingWrapper => {
          const changeEvent = new Event('change', { bubbles: true })
          freeShippingWrapper.dispatchEvent(changeEvent);
        })
      }
    } catch (error) {
      console.error('Error updating cart:', error);
    }
  };

  async function updateSideCart(cart) {
      try {
        const cartElement = document.querySelector('#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper');
        const cartContent = cartElement.querySelector('.previewCartList');
        const cartTotals = cartElement.querySelector('.previewCartTotalsPrice');

        const cartLoading = `
        <div class="loading-overlay loading-overlay--custom">
          <div class="loading-overlay__spinner">
            <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
              <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
            </svg>
          </div>
        </div>`;

        const loadingClass = 'is-loading';

        cartElement.classList.add(loadingClass);
        cartElement.insertAdjacentHTML('afterbegin', cartLoading);

        const response = await fetch(`/cart?view=ajax_side_cart`);
        const data = await response.text();
        const parsedResponse = new DOMParser().parseFromString(data, 'text/html');

        cartElement.classList.remove(loadingClass);
        cartElement.querySelector('.loading-overlay').remove();      

        if (cart.item_count > 0) {        
          const contentCart = parsedResponse.querySelector('.previewCartList').innerHTML;        
          const contentTotals = parsedResponse.querySelector('.previewCartTotalsPrice').innerHTML;

          cartContent.innerHTML = contentCart;
          cartTotals.innerHTML = contentTotals;

          document.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));

          const calculatorShipping = parsedResponse.querySelector('.haloCalculatorShipping');
          if (calculatorShipping) {
            const existingCalculator = cartElement.querySelector('.haloCalculatorShipping');
            if (existingCalculator) {
              existingCalculator.replaceWith(calculatorShipping);
            }
          }

          document.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));

          document.querySelectorAll('[data-free-shipping-wrapper]').forEach(freeShippingWrapper => {
            const changeEvent = new Event('change', { bubbles: true })
            freeShippingWrapper.dispatchEvent(changeEvent);
          })
        }
    } catch (error) {
      console.error('Error updating cart:', error);
    }
  }

  //////////// OPTIMIZED CART UPSELL NEW //////////// 
  // Enhanced visual feedback for cart count updates
  function updateCartCountWithAnimation(newCount) {
    const cartCountElements = document.querySelectorAll('[data-cart-count]');
    const cartBubbles = document.querySelectorAll('.cart-count-bubble');
    
    // Show/hide cart bubbles based on count
    cartBubbles.forEach(bubble => {
      if (newCount > 0) {
        bubble.style.display = '';
      } else {
        bubble.style.display = 'none';
      }
    });
    
    cartCountElements.forEach(element => {
      element.classList.add('updating');
      element.textContent = newCount < 100 ? newCount : '99+';
      
      setTimeout(() => {
        element.classList.remove('updating');
        element.classList.add('cart-count-updated');
        
        setTimeout(() => {
          element.classList.remove('cart-count-updated');
        }, 300);
      }, 200);
    });
  }

  // Re-sync header cart count from the server via the cached/deduplicated Shopify.getCart (global.js)
  function syncCartCountFromServer() {
    if (typeof Shopify === 'undefined' || !Shopify.getCart) return;

    Shopify.getCart(function(cart) {
      if (!cart || cart.item_count === undefined) return;
      updateCartCountWithAnimation(cart.item_count);
    });
  }

  window.syncCartCountFromServer = syncCartCountFromServer;

  // Optimized cart content update with visual feedback
  function updateCartContentWithFeedback(cartElement, newContent) {
    if (!cartElement) return;
    
    const cartContent = cartElement.querySelector('.previewCartList');
    const cartTotals = cartElement.querySelector('.previewCartTotalsPrice');
    
    if (cartContent) {
      cartContent.classList.add('updating');
      setTimeout(() => {
        cartContent.innerHTML = newContent.querySelector('.previewCartList')?.innerHTML || '';
        cartContent.classList.remove('updating');
      }, 100);
    }
    
    if (cartTotals) {
      cartTotals.classList.add('updating');
      setTimeout(() => {
        cartTotals.innerHTML = newContent.querySelector('.previewCartTotalsPrice')?.innerHTML || '';
        cartTotals.classList.remove('updating');
      }, 100);
    }
  }

  // Enhanced updateSideCartOptimized function
  async function updateSideCartOptimized(cart) {
    try {
      const cartElement = document.querySelector('#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper');
      if (!cartElement) return;

      // Show loading state
      const cartLoading = `
        <div class="loading-overlay loading-overlay--custom">
          <div class="loading-overlay__spinner">
            <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
              <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
            </svg>
          </div>
        </div>`;

      cartElement.classList.add('is-loading');
      cartElement.insertAdjacentHTML('afterbegin', cartLoading);

      // Fetch cart content in background
      const response = await fetch(`/cart?view=ajax_side_cart`);
      const data = await response.text();
      const parsedResponse = new DOMParser().parseFromString(data, 'text/html');

      // Remove loading state
      cartElement.classList.remove('is-loading');
      const loadingOverlay = cartElement.querySelector('.loading-overlay');
      if (loadingOverlay) loadingOverlay.remove();

      // Always update cart content (handle both empty and non-empty carts)
      if (parsedResponse) {
        // Get the full cart HTML content - include both previewCart and previewCartInfo
        const previewCart = parsedResponse.querySelector('.previewCart');
        const previewCartInfo = parsedResponse.querySelector('.previewCartInfo');
        const previewCartTool = parsedResponse.querySelector('.previewCartTool');
        const popupToolDowns = parsedResponse.querySelector('.popup-toolDowns');
        
        if (previewCart) {
          // Build complete cart content including footer
          let completeCartHTML = previewCart.outerHTML;
          
          // Add previewCartTool if it exists
          if (previewCartTool) {
            completeCartHTML += previewCartTool.outerHTML;
          }
          
          // Add popup-toolDowns if it exists
          if (popupToolDowns) {
            completeCartHTML += popupToolDowns.outerHTML;
          }
          
          // Add previewCartInfo (footer with checkout button) if it exists
          if (previewCartInfo) {
            completeCartHTML += previewCartInfo.outerHTML;
          }
          
          // Update entire cart content with complete HTML
          cartElement.innerHTML = completeCartHTML;
        } else {
          // Fallback to body if previewCart not found
          cartElement.innerHTML = parsedResponse.body.innerHTML;
        }

        // Dispatch cart update event (use estimated count if cart object not available)
        if (cart && cart.item_count !== undefined) {
          document.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));
        }

        // Handle calculator shipping
        const calculatorShipping = parsedResponse.querySelector('.haloCalculatorShipping');
        if (calculatorShipping) {
          const existingCalculator = document.querySelector('.haloCalculatorShipping');
          if (existingCalculator) {
            existingCalculator.replaceWith(calculatorShipping.cloneNode(true));
          }
        }

        // Handle free shipping updates
        setTimeout(() => {
          document.querySelectorAll('[data-free-shipping-wrapper]').forEach(freeShippingWrapper => {
            const changeEvent = new Event('change', { bubbles: true });
            freeShippingWrapper.dispatchEvent(changeEvent);
          });
        }, 100);
        setTimeout(() => {
          initCartUpsellSliderFast(getCartUpsellWrapper());
        }, 150);
      }
    } catch (error) {
      console.error('Error updating cart:', error);
    }
  }

  // Enhanced main cart update function
  async function updateMainCartOptimized(cart) {
    try {
      // Update cart count with animation
      updateCartCountWithAnimation(cart.item_count);

      // Dispatch cart update event
      document.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));

      // Update cart content asynchronously
      const cartContainer = document.querySelector('.cart-items');
      if (cartContainer) {
        const response = await fetch('/cart?view=ajax_main_cart');
        const data = await response.text();
        const parsedResponse = new DOMParser().parseFromString(data, 'text/html');
        
        const newCartContent = parsedResponse.querySelector('.cart-items');
        if (newCartContent) {
          cartContainer.classList.add('updating');
          setTimeout(() => {
            cartContainer.innerHTML = newCartContent.innerHTML;
            cartContainer.classList.remove('updating');
          }, 100);
        }
      }
    } catch (error) {
      console.error('Error updating main cart:', error);
    }
  }

    let cartUpsellSliderFrame = null;
  let cartUpsellSliderObserver = null;
  let cartUpsellSliderObserverTimer = null;
  
  function getCartUpsellWrapper() {
    return (
      document.querySelector('#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper') ||
      document.querySelector('#halo-cart-sidebar .previewCart-wrapper')
    );
  }
  
  function cartBool(value, fallback = false) {
    if (value === true || value === 'true') return true;
    if (value === false || value === 'false') return false;
    if (value === undefined || value === null || value === '') return fallback;
    return fallback;
  }
  
  function initCartUpsellSliderFast(scope) {

    if (!document.body.classList.contains('new-cart-drawer-design')) return;

    if (cartUpsellSliderFrame) {
      cancelAnimationFrame(cartUpsellSliderFrame);
    }
    
    cartUpsellSliderFrame = requestAnimationFrame(function () {
      if (!window.jQuery || !window.jQuery.fn || !window.jQuery.fn.slick) return;
      
      const $ = window.jQuery;
      const wrapper = scope || getCartUpsellWrapper();
      
      if (!wrapper) return;
      
      const $scope = $(wrapper);
      const sliderSelector = '.upsell-container.products-carousel, .previewCartCarousel.products-carousel';
      
      let $sliders = $scope.find(sliderSelector);
      
      if ($scope.is(sliderSelector)) {
        $sliders = $sliders.add($scope);
      }
      
      if (!$sliders.length) return;
      
      $sliders.each(function () {
        const $slider = $(this);
        
        if ($slider.hasClass('slick-initialized')) {
          $slider.slick('setPosition');
          return;
        }
        
        const itemToShowRaw = $slider.attr('data-item-to-show');
        const itemToShow = itemToShowRaw ? parseFloat(itemToShowRaw) : 2;
        
        const parentArrows = $slider.closest('.previewCartProduct').attr('data-item-arrows');
        
        const itemArrows = cartBool(
          $slider.attr('data-item-arrows'),
          cartBool(parentArrows, true)
        );
        
        const itemArrowsMb = cartBool(
          $slider.attr('data-item-arrows-mb'),
          itemArrows
        );
        
        const itemDots = cartBool($slider.attr('data-item-dots'), false);
        const itemDotsMb = cartBool($slider.attr('data-item-dots-mb'), itemDots);
        
        const $arrowBox = $slider.closest('.previewCartCollection').find('.complete-the-routine-arrows');
        if ($arrowBox.length) {
          $arrowBox.empty();
        }
        const ctrArrowSvg =
        '<svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg">' +
        '<path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z"></path>' +
        '</svg>';
        $slider.slick({
          mobileFirst: true,
          adaptiveHeight: true,
          vertical: false,
          infinite: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: itemArrowsMb,
          dots: itemDotsMb,
          rtl: window.rtl_slick || false,
          appendArrows: $arrowBox.length ? $arrowBox : $slider,
          
          prevArrow:
          '<button type="button" class="ctr-prev" aria-label="Previous">' +
          ctrArrowSvg +
          '</button>',
          
          nextArrow:
          '<button type="button" class="ctr-next" aria-label="Next">' +
          ctrArrowSvg +
          '</button>',
          responsive: [
            {
              breakpoint: 320,
              settings: {
                slidesToShow: 1.4,
                slidesToScroll: 1,
                arrows: itemArrowsMb,
                dots: itemDotsMb
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1.5,
                slidesToScroll: 1,
                arrows: itemArrowsMb,
                dots: itemDotsMb
              }
            },
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 1.8,
                slidesToScroll: 1,
                arrows: itemArrows,
                dots: itemDots
              }
            },
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 1.8,
                slidesToScroll: 1,
                arrows: itemArrows,
                dots: itemDots
              }
            }
          ]
        });
        
        $slider.slick('setPosition');
      });
    });
  }
  
  function watchCartUpsellSliderOnce() {
    const wrapper = getCartUpsellWrapper();
    
    if (!wrapper) return;
    
    if (cartUpsellSliderObserver) {
      cartUpsellSliderObserver.disconnect();
      cartUpsellSliderObserver = null;
    }
    
    if (cartUpsellSliderObserverTimer) {
      clearTimeout(cartUpsellSliderObserverTimer);
      cartUpsellSliderObserverTimer = null;
    }
    
    cartUpsellSliderObserver = new MutationObserver(function () {
      initCartUpsellSliderFast(getCartUpsellWrapper());
    });
    
    cartUpsellSliderObserver.observe(wrapper, {
      childList: true,
      subtree: true
    });
    
    cartUpsellSliderObserverTimer = setTimeout(function () {
      if (cartUpsellSliderObserver) {
        cartUpsellSliderObserver.disconnect();
        cartUpsellSliderObserver = null;
      }
    }, 2500);
  }
  

  // Enhanced add to cart event listener with better visual feedback
  document.addEventListener('click', async (elm) => {
    let addToBagBtn = elm.target.closest('.add_to_bag');
    if (addToBagBtn) {
      // Prevent multiple clicks
      if (addToBagBtn.classList.contains('is-loading')) return;
      
      addToBagBtn.classList.add('is-loading');
      const originalText = addToBagBtn.textContent;
      addToBagBtn.innerHTML = '<div class="loader"><span style="display: none;">loading</span></div>';
      
      const productId = addToBagBtn.getAttribute('data-id');  

      try {
        // Add item to cart (no parallel cart.js call to avoid 429 errors)
        const addResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: productId,
              quantity: 1
            }]
          })
        });

        if (!addResponse.ok) {
          throw new Error('Failed to add item to cart');
        }

        const addData = await addResponse.json();
        
        // Get current cart count and increment (avoid API call)
        const currentCountEl = document.querySelector('[data-cart-count]');
        const currentCount = parseInt(currentCountEl?.textContent || '0') || 0;
        const newCount = currentCount + 1;
        
        // Update cart count with animation for instant feedback
        updateCartCountWithAnimation(newCount);

        // Show cart sidebar immediately
        if (window.halo && typeof window.halo.lockBodyScroll === 'function') {
          window.halo.lockBodyScroll();
        } else {
          // Fallback if halo is not available
          var scrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
          document.body.style.top = '-' + scrollY + 'px';
          document.body.classList.add('cart-sidebar-show');
          document.documentElement.classList.add('cart-sidebar-show');
        }

        // Update cart content using HTML view (no JSON API calls to avoid 429)
        if (document.querySelector(".template-cart")) {
          // For main cart page, use section update
          const sectionId = document.querySelector('#main-cart-items')?.getAttribute('data-id');
          if (sectionId) {
            setTimeout(() => {
              fetch(`/cart?section_id=${sectionId}`)
                .then(response => response.text())
                .then(html => {
                  const parser = new DOMParser();
                  const doc = parser.parseFromString(html, 'text/html');
                  const cartContent = doc.querySelector('[data-cart-content]');
                  if (cartContent) {
                    const existingCart = document.querySelector('[data-cart-content]');
                    if (existingCart) {
                      existingCart.innerHTML = cartContent.innerHTML;
                    }
                  }
                })
                .catch(error => console.error('Error updating main cart:', error));
            }, 300);
          }
        } else {
          // For sidebar cart, use HTML view with delay to avoid rate limits
          setTimeout(() => {
            if (window.halo && typeof window.halo.loadSidebarCartHTML === 'function') {
              window.halo.loadSidebarCartHTML();
            } else if (typeof updateSideCartOptimized === 'function') {
              // Use the optimized update function that preserves footer
              fetch('/cart.js')
                .then(response => {
                  if (!response.ok) throw new Error('Cart fetch failed: ' + response.status);
                  return response.json();
                })
                .then(async cart => {
                  updateSideCartOptimized(cart);
                  setTimeout(() => {
                    watchCartUpsellSliderOnce();
                    initCartUpsellSliderFast(getCartUpsellWrapper());
                  }, 200);
                })
                .catch(error => console.error('Error loading cart:', error));
            } else {
              // Fallback: use HTML view directly
              const cartElement = document.querySelector('#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper');
              if (cartElement && !cartElement.classList.contains('is-loading')) {
                const rootPath = window.routes && window.routes.root ? window.routes.root : '';
                fetch(`${rootPath}/cart?view=ajax_side_cart`)
                  .then(response => response.text())
                  .then(html => {
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(html, 'text/html');
                    const previewCart = doc.querySelector('.previewCart');
                    const previewCartInfo = doc.querySelector('.previewCartInfo');
                    const previewCartTool = doc.querySelector('.previewCartTool');
                    const popupToolDowns = doc.querySelector('.popup-toolDowns');
                    
                    if (previewCart) {
                      // Build complete cart content including footer
                      let completeCartHTML = previewCart.outerHTML;
                      
                      if (previewCartTool) {
                        completeCartHTML += previewCartTool.outerHTML;
                      }
                      
                      if (popupToolDowns) {
                        completeCartHTML += popupToolDowns.outerHTML;
                      }
                      
                      if (previewCartInfo) {
                        completeCartHTML += previewCartInfo.outerHTML;
                      }
                      
                      cartElement.innerHTML = completeCartHTML;
                      
                      if (window.halo && typeof window.halo.dispatchChangeForShippingMessage === 'function') {
                        window.halo.dispatchChangeForShippingMessage();
                      }
                    }
                  })
                  .catch(error => console.error('Error loading cart:', error));
              }
            }
            
            // Ensure scrolling and footer visibility after update
            setTimeout(() => {
              const cartSidebar = document.querySelector('#halo-cart-sidebar');
              // const cartWrapper = document.querySelector('#halo-cart-sidebar .previewCart-wrapper');
              const cartWrapper = getCartUpsellWrapper();
              
              // Ensure cart sidebar is scrollable
              if (cartSidebar) {
                cartSidebar.style.overflowY = 'auto';
                cartSidebar.style.overflowX = 'hidden';
              }
              if (cartWrapper) {
                cartWrapper.style.overflowY = 'auto';
                cartWrapper.style.overflowX = 'hidden';
              }
              
              // Ensure footer section is visible
              const allPreviewCartInfo = document.querySelectorAll('#halo-cart-sidebar .previewCartInfo, .halo-cart-sidebar .previewCartInfo, .previewCart-wrapper .previewCartInfo');
              allPreviewCartInfo.forEach(element => {
                element.style.display = 'block';
                element.style.visibility = 'visible';
                element.style.opacity = '1';
              });
              
              const allPreviewCartAction = document.querySelectorAll('#halo-cart-sidebar .previewCartAction, .halo-cart-sidebar .previewCartAction, .previewCart-wrapper .previewCartAction');
              allPreviewCartAction.forEach(element => {
                element.style.display = 'block';
                element.style.visibility = 'visible';
                element.style.opacity = '1';
              });
              
              const allButtonCheckout = document.querySelectorAll('#halo-cart-sidebar .button-checkout, .halo-cart-sidebar .button-checkout, .previewCart-wrapper .button-checkout');
              allButtonCheckout.forEach(element => {
                element.style.display = 'block';
                element.style.visibility = 'visible';
                element.style.opacity = '1';
              });
              initCartUpsellSliderFast(cartWrapper);
            }, 300);
          }, 500);
        }

      } catch (error) {
        console.error('Error adding to cart:', error);
        // Show error message if needed
      } finally {
        // Restore button state
        addToBagBtn.classList.remove('is-loading');
        addToBagBtn.textContent = originalText;
      }
    }
  });

// Cart loading state management
let cartLoadingInProgress = false;
let cartLoadTimeout = null;
let lastCartLoadTime = 0;
const CART_LOAD_DEBOUNCE = 1000; // Minimum time between cart loads (ms)
const CART_LOAD_COOLDOWN = 3000; // Cooldown period after a load (ms)

// Load cart content when sidebar is opened
function loadCartContent() {
  // Prevent duplicate requests
  if (cartLoadingInProgress) {
    return;
  }
  
  // Check cooldown period
  const now = Date.now();
  if (now - lastCartLoadTime < CART_LOAD_COOLDOWN) {
    return;
  }
  
  const cartWrapper = document.querySelector('#halo-cart-sidebar .previewCart-wrapper');
  if (!cartWrapper) return;
  
  // Check if cart content is empty or needs refresh
  const hasContent = cartWrapper.innerHTML.trim() && cartWrapper.querySelector('.previewCart') !== null;
  if (hasContent) {
    // Cart already has content, don't reload
    return;
  }
  
  cartLoadingInProgress = true;
  lastCartLoadTime = now;
  
  // Always use HTML view directly (no JSON API calls to avoid 429 errors)
  loadCartHTML();
}

// Function to load cart HTML directly (no JSON requests)
function loadCartHTML() {
  const cartWrapper = document.querySelector('#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper');
  if (!cartWrapper) {
    cartLoadingInProgress = false;
    return;
  }
  
  // Show loading state
  cartWrapper.classList.add('is-loading');
  const loadingHTML = '<div class="loading-overlay loading-overlay--custom"><div class="loading-overlay__spinner"><svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div></div>';
  cartWrapper.insertAdjacentHTML('afterbegin', loadingHTML);
  
  // Get the root path
  const rootPath = window.routes && window.routes.root ? window.routes.root : '';
  const cartUrl = rootPath + '/cart?view=ajax_side_cart';
  
  fetch(cartUrl)
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.text();
    })
    .then(html => {
      cartWrapper.classList.remove('is-loading');
      const loadingOverlay = cartWrapper.querySelector('.loading-overlay');
      if (loadingOverlay) loadingOverlay.remove();
      
      // Parse and insert the cart HTML
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const cartContent = doc.querySelector('.previewCart') || doc.body;
      
      if (cartContent) {
        cartWrapper.innerHTML = cartContent.innerHTML || cartContent.outerHTML;
        
        // Dispatch events for shipping message and other updates
        if (window.halo && typeof window.halo.dispatchChangeForShippingMessage === 'function') {
          window.halo.dispatchChangeForShippingMessage();
        }
      }
      
      cartLoadingInProgress = false;
    })
    .catch(error => {
      console.error('Error loading cart:', error);
      cartWrapper.classList.remove('is-loading');
      const loadingOverlay = cartWrapper.querySelector('.loading-overlay');
      if (loadingOverlay) loadingOverlay.remove();
      cartLoadingInProgress = false;
    });
}

// Debounced cart load function
function debouncedLoadCart() {
  if (cartLoadTimeout) {
    clearTimeout(cartLoadTimeout);
  }
  
  cartLoadTimeout = setTimeout(function() {
    loadCartContent();
    cartLoadTimeout = null;
  }, CART_LOAD_DEBOUNCE);
}

// Only initialize if theme.js cart loading isn't working properly
document.addEventListener('DOMContentLoaded', function() {
  // Wait a bit to see if theme.js handles it
  setTimeout(function() {
    let observerActive = false;
    let lastObserverTrigger = 0;
    
    // Use MutationObserver to watch for cart-sidebar-show class
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const body = mutation.target;
          if (body.classList.contains('cart-sidebar-show')) {
            const now = Date.now();
            // Prevent rapid triggers
            if (now - lastObserverTrigger < 2000) {
              return;
            }
            lastObserverTrigger = now;
            
            if (!observerActive) {
              observerActive = true;
              // Check if cart needs loading (only if empty)
              const cartWrapper = document.querySelector('#halo-cart-sidebar .previewCart-wrapper');
              if (cartWrapper && (!cartWrapper.innerHTML.trim() || !cartWrapper.querySelector('.previewCart'))) {
                debouncedLoadCart();
              }
              // Reset flag after a delay
              setTimeout(function() {
                observerActive = false;
              }, 2000);
            }
          }
        }
      });
    });

    // Start observing the body element for class changes
    if (document.body) {
      observer.observe(document.body, {
        attributes: true,
        attributeFilter: ['class']
      });
    }
  }, 500);
});

  // document.documentElement.addEventListener('cart:refresh', function () {
  //   $('.ctm_cart_unsell').slick({
  //     infinite: true,
  //     slidesToShow: 1,
  //     slidesToScroll: 1,
  //     dots: false,
  //     prevArrow: '<button type="button" class="slick-prev custom_slick_prev"><img src="https://cdn.shopify.com/s/files/1/2330/4667/files/left-arrow_2.png?v=1718100689" alt="Previous" /></button>',
  //     nextArrow: '<button type="button" class="slick-next custom_slick_next"><img src="https://cdn.shopify.com/s/files/1/2330/4667/files/right-arrow_4_51a5f9c7-2b14-4040-b6ed-d168dd615242.png?v=1718099941" alt="Next" /></button>'
  //   });
  // });

  document.addEventListener("DOMContentLoaded", function () {

    function Collectionhover() {
      if (window.matchMedia("(min-width:1px)").matches) {
        const hoverItems = document.querySelectorAll('.collection_hover_items');

        function removeAllActiveHover() {
          hoverItems.forEach(function (elem) {
            elem.classList.remove('active_hover');
          });
        }

        if (hoverItems.length > 0) {
          hoverItems[0].classList.add('active_hover');
        }

        hoverItems?.forEach(function (currElem) {
          currElem.addEventListener('mouseover', function () {
            removeAllActiveHover();
            currElem.classList.add('active_hover');
          });


        });
      }

      if (window.matchMedia("(max-width:1366px)").matches) {
        const items = document.querySelectorAll('.collection_hover_items');

        function handleClick(event) {
          const clickedItem = event.target.closest('.collection_hover_items');
          if (!clickedItem) return; // Exit if the click isn't on a relevant element
          items.forEach(item => item.classList.remove('hover_active'));
          clickedItem.classList.add('hover_active');
        }

        document.addEventListener('click', handleClick);
        if (items.length > 0) {
          items[0].classList.add('hover_active');
        }
      }

      if (window.matchMedia("(min-width:768px)").matches) {
        var innerElement = document.querySelector('.hover_active .coll_hover_text_inner');
        var parentElements = document.querySelectorAll('.collection_hover_items');

        if (innerElement) {
          function calculateTotalHeight(element) {
            var style = window.getComputedStyle(element);
            var margin = parseFloat(style.marginTop) + parseFloat(style.marginBottom);
            var padding = parseFloat(style.paddingTop) + parseFloat(style.paddingBottom);
            var totalHeight = element.offsetHeight + margin + padding;
            return totalHeight;
          }

          parentElements.forEach(function (parentElement) {
            var totalHeight = calculateTotalHeight(innerElement) + 60; // Adding 60 pixels

            if (totalHeight < 520) {
              totalHeight = 520;
            }

            parentElement.style.height = totalHeight + 'px';
            // console.log('Applied total height to .collection_hover_items:', totalHeight);
          });
        } else {
        }
      }

      function calculateTotalHeight(element) {
        var height = element.offsetHeight;
        var style = window.getComputedStyle(element);

        height += parseInt(style.marginTop) + parseInt(style.marginBottom);
        height += parseInt(style.paddingTop) + parseInt(style.paddingBottom);
        height += parseInt(style.borderTopWidth) + parseInt(style.borderBottomWidth);

        return height;
      }
    }

    Collectionhover();
    document.addEventListener('resize', Collectionhover)


    // =============== Video play pause ================
    document.querySelectorAll('.video_item')?.forEach(function (currVideo) {
      const videoElem = currVideo.querySelector('.ctm_vedio_pay_pause');
      const playButton = currVideo.querySelector('#video_play_button');
      const pauseButton = currVideo.querySelector('#video_pause_button');

      pauseButton.style.display = 'none';

      currVideo.querySelector('.ctm_video_buttons').addEventListener("click", function (event) {

        if (event.target.closest('#video_play_button') === playButton) {
          videoElem.play();
          playButton.style.display = 'none';
          pauseButton.style.display = 'inline-flex';
        } else if (event.target.closest('#video_pause_button') === pauseButton) {
          videoElem.pause();
          pauseButton.style.display = 'none';
          playButton.style.display = 'inline-flex';
        }
      });

      videoElem.addEventListener('ended', function () {
        playButton.style.display = 'inline-flex';
        pauseButton.style.display = 'none';
      });
    });


    //=========== Video section Initialize Swiper=======
    // Scoped to the video slider only: '.swiper' also matched every other section's slider
    // (each of which initialises its own Swiper), causing duplicate init on those elements.
    new Swiper('.swiper.video_main_wrapper', {
      loop: true,
      grabCursor: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet: (index, className) =>
          `<span class="${className}" data-index="${index}"></span>`
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      slidesPerView: 5,
      slidesPerGroup: 2,
      spaceBetween: 20,
      breakpoints: {
        320: {
          slidesPerView: "auto",
          spaceBetween: 10,
          centeredSlides: false,
          slidesPerGroup: 2
        },
        480: {
          slidesPerView: 3,
          spaceBetween: 20,
          slidesPerGroup: 2
        },
        1240: {
          slidesPerView: 5,
          spaceBetween: 20,
          slidesPerGroup: 2
        }
      }
    });

  new Swiper('.ingredient_swiper', {
      loop: false,
      grabCursor: true,
      slidesPerView: 3,
      spaceBetween: 20,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      breakpoints: {
        320: {
          slidesPerView: 1.25, // 👈 shows 1 full + part of 2nd
          spaceBetween: 10,
        },
        480: {
          slidesPerView:  1.25,
          spaceBetween: 20
        },
        768: {
          slidesPerView: 2.25,
          spaceBetween: 20
        },
        1024: {
          slidesPerView: 2.75,
          spaceBetween: 20
        },
        1240: {
          slidesPerView: 3,
          spaceBetween: 20
        },
        1400: {
          slidesPerView: 4,
          spaceBetween: 20
        }
      }
    });
  new Swiper('.blog_post_swiper', {
      loop: false,
      grabCursor: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet: (index, className) =>
          `<span class="${className}" data-index="${index}"></span>`
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      slidesPerView: 4.2,
      slidesPerGroup: 1,
      spaceBetween: 20,
      breakpoints: {
        320: {
          slidesPerView: 1.2,
          spaceBetween: 10,
          centeredSlides: false,
          slidesPerGroup: 1
        },
        480: {
          slidesPerView: 2.2,
          spaceBetween: 20,
          slidesPerGroup: 1
        },
        700: {
          slidesPerView: 3.2,
          spaceBetween: 20,
          slidesPerGroup: 1
        },
        1240: {
          slidesPerView: 4.2,
          spaceBetween: 20,
          slidesPerGroup: 1
        }
      }
    });

    // document.querySelectorAll("[data-btn-addtocart]")?.forEach(function (curElm) {
    //   curElm.addEventListener("click", function (e) {
    //     e.preventDefault();  
    //     document.body.classList.add("cart-sidebar-show");
    //     const $cartDropdown = $('#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper');
    //     const $cartLoading = '<div class="loading-overlay loading-overlay--custom">\
    //               <div class="loading-overlay__spinner">\
    //                   <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">\
    //                       <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>\
    //                   </svg>\
    //               </div>\
    //           </div>';
    //     const loadingClass = 'is-loading';

    //     $cartDropdown
    //       .addClass(loadingClass)
    //       .prepend($cartLoading);

    //     document.querySelector("[data-shipping-message]").innerHTML = "";
    //     document.querySelector("[data-cart-count]").innerHTML = "";
    //   })
    // })

  });

  document.addEventListener("DOMContentLoaded", function () {
    const nodes = document.querySelectorAll('.animating_node');
    let currentIndex = 0;

    function showNextNode() {
      nodes[currentIndex]?.classList.remove('active');
      currentIndex = (currentIndex + 1) % nodes.length;
      nodes[currentIndex]?.classList.add('active');
    }

    // Rotate only while the text is on screen (and not at all on pages without it).
    function startAnimation() {
      if (!nodes.length) return;
      nodes[currentIndex].classList.add('active');
      let timer = null;
      const run = (on) => {
        if (on && !timer) timer = setInterval(showNextNode, 2000);
        if (!on && timer) { clearInterval(timer); timer = null; }
      };
      if (!('IntersectionObserver' in window)) return run(true);
      const visible = new Set();
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => e.isIntersecting ? visible.add(e.target) : visible.delete(e.target));
        run(visible.size > 0);
      });
      new Set([...nodes].map((n) => n.parentElement)).forEach((el) => io.observe(el));
    }

    startAnimation();

    //  Video Section Play Pause Obserever 
    const handleVideoPlayback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.play();
        } else {
          entry.target.pause();
        }
      });
    };

    const videoObserver = new IntersectionObserver(handleVideoPlayback, { threshold: 0.5 });

    document.querySelectorAll("video.text_with_video")?.forEach((video) => {
      videoObserver.observe(video);
    });

    updatePricePerGram();

    // Sticky ATC bar: previously revealed once the subscription widget had loaded, now shown directly.
    const stickyBtn = document.querySelector('.sticky_btn');
    if (stickyBtn) {
      stickyBtn.style.display = 'block';
    }

    // sticky product atc buttons

    ['.sticky_btn_atc_mobile', '.sticky_btn_atc_desktop'].forEach(selector => {
      document.querySelector(selector)?.addEventListener('click', () => {
        console.log('click occures')
        document.querySelector('.product-form__buttons button')?.click();
      });
    });
    
    function refresh_product_check() {
      const atcPrice = document.querySelector('.product-form__buttons .price__regular .price__last .price-item--regular')?.textContent.trim();
      if (!atcPrice) return;
      const priceSpan = document.querySelector('.sticky_btn_atc_desktop span');
      if (priceSpan) {
        priceSpan.innerText = atcPrice;
      }
    }

    refresh_product_check();
  });

  // product video slider

    document.addEventListener('DOMContentLoaded', function () {
      const slider = document.querySelector('.product_video_slider');
      const popupInner = document.querySelector('.popup_product_video_inner');
      const popupContainer = document.querySelector('.popup_product_container');
      const closeButton = document.querySelector('.remove_popup_product_video');
      const closeButtonOverlay = document.querySelector('.popup_product_video_overlay');

      // Show the popup
      function showPopup() {
        if (popupContainer) {
          popupContainer.style.display = 'block';
        }
      }

      // Hide popup on 'X' click
      if (closeButton && popupContainer) {
        closeButton.addEventListener('click', function () {
          popupContainer.style.display = 'none';
          popupInner.innerHTML = '';
        });
        closeButtonOverlay.addEventListener('click', function () {
          popupContainer.style.display = 'none';
          popupInner.innerHTML = '';
        });
      }

      // Handle video click to open popup
      if (slider && popupInner) {
        slider.addEventListener('click', function (e) {
          const clickedItem = e.target.closest('.product_video_item');
          if (!clickedItem) return;

          const clickedVideo = clickedItem.querySelector('video');
          if (!clickedVideo) return;

          const isMuted = document.querySelector('.popup_product_videos .vdo_unmute_btn')?.style.display == "none";

          const clonedVideo = clickedVideo.cloneNode(true);
          clonedVideo.controls = false;
          clonedVideo.autoplay = true;
          clonedVideo.muted = isMuted;

          popupInner.innerHTML = '';
          popupInner.appendChild(clonedVideo);

          showPopup();
        });
      }

      // Optional: make showPopup globally callable
      window.showPopupProductVideo = showPopup;

      $('.product_video_slider').slick({
        infinite: true,
          slidesToShow: 5,
          slidesToScroll: 5,
          arrows: false,
          responsive: [
            {
              breakpoint: 1300,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 4
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3
              }
            }
          ]
        });
    });

  document.addEventListener("click", function (e) {
    if (e.target.closest(".popup_product_videos .vdo_unmute_btn")) {
        const video = document.querySelector(".popup_product_videos .product_ctm_vedio_pay_pause");
        if (video) video.muted = true;
        e.target.closest(".popup_product_videos .vdo_unmute_btn").style.display = "none";
        document.querySelector(".popup_product_videos .vdo_mute_btn").style.display = "block";
    }

    if (e.target.closest(".popup_product_videos .vdo_mute_btn")) {
        const video = document.querySelector(".popup_product_videos .product_ctm_vedio_pay_pause");
        if (video) video.muted = false;
        e.target.closest(".popup_product_videos .vdo_mute_btn").style.display = "none";
        document.querySelector(".popup_product_videos .vdo_unmute_btn").style.display = "block";
    }
  });


  function toggleStickyBit() {
    const formButtons = document.querySelector('.multiColumn_conn');
    const sticky = document.querySelector('.sticky_bit');

    if (formButtons && sticky) {
      const rect = formButtons.getBoundingClientRect();
      const offsetTop = rect.top + window.scrollY;
     
    //  console.log(offsetTop);
      if (window.scrollY >= offsetTop) {
        sticky.classList.add('visible');
      } else {
        sticky.classList.remove('visible');
      }
    }
  }

  // function toggleStickyBit() {
  //   const sticky = document.querySelector('.sticky_bit');

  //   if (sticky) {

  //     if (window.scrollY >= 1600) {
  //       sticky.classList.add('visible');
  //     } else {
  //       sticky.classList.remove('visible');
  //     }
  //   }
  // }

  window.addEventListener('scroll', toggleStickyBit);
  window.addEventListener('load', toggleStickyBit);

  function updatePricePerGram() {
    const connectedProducts = document.querySelectorAll('.meta_connected_prd');
    
    connectedProducts.forEach(product => {
      const priceElement = product.querySelector('.prod_var_price');
      const pricePerGramElement = product.querySelector('.prod_price_gram');
      const actualPriceElement = product.querySelector('.prod_ac_price');
      
      if (priceElement && pricePerGramElement && actualPriceElement) {
        const grams = parseInt(priceElement.textContent.trim());
        const actualPrice = parseInt(actualPriceElement.textContent.trim()) / 100;
        
        const pricePerGram = (actualPrice / grams).toFixed(2);
        pricePerGramElement.textContent = `$${pricePerGram}/g`;
      }
    });
  }

  // Make function globally available
  window.updatePricePerGram = updatePricePerGram;